export const dashboard = {
  title: 'Dashboard',
  statisticsTitle: 'Statistics',
  navigationTitle: 'Quick navigation',
  navigationDescription: 'Go directly to any system section',
  noSections: 'No sections available',
  tilesError: 'Unable to load navigation tiles',
  sectionsError: 'Unable to load statistics data',
  sections: {
    dashboardDesc: 'Main view with navigation and key data',
    statisticsDesc: 'Charts and activity statistics from the last 30 days',
    profileDesc: 'Manage your user profile',
  },
  chart: {
    criterion: 'Criterion {position}',
    title: '{name}: most popular values',
    period: 'Last 30 days',
    total: 'Total: {count}',
    values: 'Values: {count}',
    mostCommon: 'Most common: {label} ({share}%)',
    noData: 'No data in this period',
  },
} as const
